<template>
  <div class='mobile-nav' :class="{'not-border': !nav_title}" :style="{paddingLeft: padding_left+'px'}">
    <div class='left-btn' @click="mobileNavBtn('left')" v-if="isShowLeftIcon">
      <span v-if="!isWxMini" :class="`iconfont ${icon} ${cvShow ? 'cv-icon' : '' }`" />
      <span v-if="left_text">{{left_text}}</span>
    </div>
    <div class='nav-title' v-if="nav_title">{{nav_title}}</div>
    <div class='right-btn flex-center' v-if='right_btn_html' v-html='right_btn_html' @click="mobileNavBtn('right')"></div>
    <slot name="rightContent"></slot>
  </div>
</template>

<script>
import { envMixin } from '../../assets/js/mixin/global'
export default {
  mixins: [envMixin],
  props: {
    left_btn: '',
    left_btn_html: '',
    nav_title: '',
    right_btn_html: '',
    left_text: '',
    isShowLeftIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'iconchevron-left'
    },
    padding_left: {
      type: String,
      default: '10'
    },
    cvShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    mobileNavBtn (direction) {
      if (direction === 'left') {
        this.$emit('mobileLeftBtn')
      } else if (direction === 'right') {
        this.$emit('mobileRightBtn')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile-nav {
  padding-left: 10px;
  padding-right: 24px;
  position: fixed;
  margin: 0;
  top: 0;
  left: 0;
  height: 44px;
  color: #404040;
  z-index: 99;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  box-sizing: border-box;
}
.not-border {
  border-bottom: none;
}
.mobile-nav .nav-title {
  color: #000;
  font-size: 17px;
  position: absolute;
  right: 0;
  left: 0;
  text-align: center;
  width: 50%;
  margin: 0 auto;
  height: 100%;
  line-height: 44px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.left-btn {
  display: flex;
  align-items: center;
  font-size: 16px;
  .iconfont {
    font-size: 26px;
    font-weight: bold;
    margin-right: 16px;
    &.iconmenu {
      font-weight: 400;
      font-size: 22px;
    }
  }
  .cv-icon {
    margin-right: 0;
  }
}
.right-btn {
  height: 100%;
  font-size: 16px;
  color: #FF4F4C;
}
</style>
